import { Box, Typography } from '@material-ui/core'

import { useAppSelector } from 'store'

import { PremiumWrapper } from '../components/PremiumPreview/PremiumWrapper'
import DataPointsGrid from './DataPointsGrid'
import { HighschoolData } from './useGetHighschoolPreviewData'

const LocationDetails = ({ highschool }: { highschool: HighschoolData }) => {
  const isPremiumExplorerEnabled = useAppSelector(
    (state) => state.college.record?.Features?.SupportsPremiumHighSchoolExplorer || false,
  )
  if (!highschool) return null
  return (
    <Box
      display="flex"
      flexDirection="column"
      gridGap={16}
    >
      <Typography variant="h6">Location</Typography>
      <PremiumWrapper
        enabled={isPremiumExplorerEnabled}
        trackingIdPlacement="location-details"
        variant="small"
      >
        <DataPointsGrid
          dataPoints={[
            {
              title: 'Geomarket',
              data: highschool.geomarket,
              isPremium: true,
            },
            { title: 'Locale', data: highschool.locale, isPremium: true },
          ]}
        />
      </PremiumWrapper>
    </Box>
  )
}

export default LocationDetails
